export default __webpack_public_path__ + "static/media/dhaka.a315809a.jpg";